import { Stack, Typography } from '@montugroup/design-system';
import { Box } from '@mui/material'; //todo: https://montugroup.atlassian.net/browse/UMED-7743
import SuccessConfetti from '../../../assets/images/onboard/success-confetti.gif';

export const ScriptValid = () => {
  return (
    <Stack gap={6} sx={{ textAlign: 'center' }} data-testid="pharmacist-escript-script-valid">
      <Box
        component="img"
        src={SuccessConfetti}
        sx={{
          width: '90px',
          height: '120px',
          alignSelf: 'center',
        }}
      />
      <Typography variant="subtitle1" fontWeight={600}>
        Good news! The medication is available
      </Typography>
      <Typography>
        Communications have been sent to your customer with the next steps to continue with uMeds.
      </Typography>
    </Stack>
  );
};
